<div class="approval-box">
  <div class="approval-box-action" *ngIf="feedbackStatus.status_code == APPROVAL_STATUS.PENDING_CODE ">
    <div class="action-approve">
        <core-helpers-forms-button [type]="'green'" [text]="'APPROVE'" (click)="onApprove($event)"></core-helpers-forms-button>
        <figure class="action-icon approve-ico"></figure>
    </div>
    <div class="action-message"><span>Your approval is required</span></div>
    <div class="action-reject">
      <figure class="action-icon reject-ico"></figure>
      <core-helpers-forms-button [type]="'red'" [text]="'REJECT'" (click)="onReject($event)"></core-helpers-forms-button>
    </div>
  </div>
  <div class="approval-box-action approved-artwork" *ngIf="feedbackStatus.status_code == APPROVAL_STATUS.APPROVED_CODE">
    <div class="action-message"><span>You Approved this artwork on {{satusDate | date: 'dd MMM yyyy'}}</span></div>
    <figure class="action-icon approve-ico" ></figure>
  </div>
  <div class="approval-box-action rejected-artwork" *ngIf="feedbackStatus.status_code == APPROVAL_STATUS.REJECTED_CODE">
    <div class="action-message"><span>You Rejected this artwork on {{satusDate | date: 'dd MMM yyyy'}}</span></div>
    <figure class="action-icon reject-ico" ></figure>
  </div>
</div>
